import React from 'react';
import { Helmet } from 'react-helmet-async';

const OilToDryPage = () => {
  // Basic accordion logic
  const handleAccordion = (e) => {
    const header = e.currentTarget;
    const content = header.nextElementSibling;
    const icon = header.querySelector('i');
    content.classList.toggle('active');
    icon.style.transform = content.classList.contains('active') ? 'rotate(180deg)' : 'rotate(0deg)';
  };

  return (
    <>
      <Helmet>
        <title>Замена масляного трансформатора на сухой: выгоды, кейс, окупаемость</title>
      </Helmet>
      <main>{/* HTML content will be placed and adapted here */}</main>
    </>
  );
};

export default OilToDryPage;
